<script setup>
import {computed, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute, useRouter} from 'vue-router';
import BondDetailContent from '@/components/bonds/BondDetailContent.vue';
import {useBondsPageGuard} from '@/utils/features';

/**
 * Stránka detailu dluhopisu pro klienta (/bonds/:id) a poradce (/advisor/bonds/:id, route meta.advisor).
 * Obsah je v BondDetailContent – stejný jako v modalu „Detail“ ve výběru dluhopisů v kalkulačce onboardingu.
 */
const {t} = useI18n();
// v instanci bez dluhopisů (B.I.G. Invest SK/CZ) stránka přesměruje na nástěnku
useBondsPageGuard();
const route = useRoute();
const router = useRouter();
const isAdvisor = computed(() => route.meta.advisor === true);
// načtený dluhopis z obsahu – jen kvůli názvu v záhlaví
const bond = ref(null);

function goBack() {
  router.push({name: isAdvisor.value ? 'AdvisorBonds' : 'ClientBonds'});
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="goBack" class="page-section__heading__back cursor-pointer"><i class="mdi mdi-chevron-left"></i> {{ t('clientBonds.back_to_bonds') }}</a>
        </div>
        <div class="col-6 text-center">
          <div class="page-section__title">{{ bond?.name ?? t('clientBonds.detail_title') }}</div>
        </div>
        <div class="col-3"></div>
      </div>
    </div>
    <div class="page-section__content">
      <!-- key: přechod mezi detaily dvou dluhopisů načte obsah znovu -->
      <BondDetailContent :key="route.params.id" :bond-id="route.params.id" :advisor="isAdvisor" @loaded="bond = $event"/>
    </div>
  </div>
</template>
